import { compose, withProps } from "recompose";
import * as hoc from "modules/user/auth/hoc";
import { isOnboardedCandidate } from "modules/user/auth/model";
import * as selectors from "modules/referral/selectors";
import * as api from "modules/referral/api";

import View from "./View";

export default compose(
  hoc.authorized(isOnboardedCandidate),
  withProps({
    submitApiSelector: selectors.sendInvitationApi,
    submitReferralApi: api.sendInvitation,
    invitationEvent: "candidateInvitationSent",
    title: "Share the love, send a $20 credit to your friends"
  })
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Referral/Provider.js